import {
  FlexColumn, useFormConfigurationContext,
} from '@equifinance/shared';
import styled from 'styled-components';
import { useChecklistContext } from '../../../../../../contexts';
import { ChecklistSection } from '../../../../ChecklistPage';
import { PaddedGenericSection } from '../../../GenericSection';
import DocumentList from './DocumentList';
import UploadDocuments from '../../../../../UploadDocuments';
import { filesToChecklistDocuments } from '../../../../common/checklistDocument';

const DocumentSectionContainer = styled(FlexColumn)`${({ theme }) => `
  gap: ${theme.padding[3]};
`}`;

export default function DocumentsSection() {
  const { checklist, uploadChecklistDocuments } = useChecklistContext();
  const { sendOffer } = checklist ?? {};
  const { isDisabled } = useFormConfigurationContext();

  const uploadingFiles = async (files: File[]) => {
    const documents = await filesToChecklistDocuments(files);
    await uploadChecklistDocuments({ checklistSectionId: sendOffer?.id!, documents });
  };

  return (
    <PaddedGenericSection
      title="Documents"
      subSection={ChecklistSection.SEND_OFFER_DOCUMENTS}
      level={1}
    >
      <DocumentSectionContainer>
        <DocumentList documents={sendOffer?.documents ?? []} />
        <UploadDocuments
          disabled={isDisabled}
          uploadingFiles={uploadingFiles}
        />
      </DocumentSectionContainer>
    </PaddedGenericSection>
  );
}
